import classNames from "classnames";
import { MenuProps } from "@mui/material";
import { TMenuIds } from "../../../../app/state/menuSlice/types";
import { MenuItems } from "../../types";
import { useMenuSelectors } from "../../../../app/state/menuSlice/hook/use-menu-selectors";
import { MenuBasic } from "../../../Components/Menu/MenuBasic";
import { AppMenuItem } from "../../../../shared/components/AppMenu/AppMenuItem";
import { RootFolderIcon } from "../../../../shared/icons/RootFolderIcon";
import { FolderCloseIcon } from "../../../../shared/icons/FolderCloseIcon";
import { AppMenuProps } from "../../../Components/Menu/types";
import styles from "./styles.module.css";
import { useMemo } from "react";

interface Props
  extends Omit<AppMenuProps, "isOpen" | "position" | "onClose" | "children"> {
  folders: MenuItems;
  closeMenu: (id: TMenuIds, subtype?: "sidebar" | "menu") => void;
  subtype: "sidebar" | "menu";
  handleTransfer: (id: string) => void;
  currentFolderId?: string | null;
  reset?: () => void;
  submenuRef?: React.RefObject<HTMLDivElement>;
}

export const SidebarTransferMenu = ({
  folders,
  submenuRef,
  subtype,
  currentFolderId,
  handleTransfer,
  closeMenu,
  reset,
  ...props
}: Props) => {
  const sidebarTransferMenu = useMenuSelectors("sidebar_item_transfer_menu");

  const foldersArray = useMemo(() => {
    const newFolderItems = folders.filter(
      (folder) => folder.value === null && folder.id !== currentFolderId,
    );
    return currentFolderId
      ? [
          ...newFolderItems,
          {
            id: "root",
            name: "Корневой каталог",
            value: null,
            children: null,
            parentId: null,
          },
        ]
      : newFolderItems;
  }, [folders, currentFolderId]);

  return (
    <MenuBasic
      ref={submenuRef}
      isOpen={
        sidebarTransferMenu.isOpen && sidebarTransferMenu.subtype === subtype
      }
      position={sidebarTransferMenu.position}
      onClose={(e, reason) => {
        reset?.();
        closeMenu("sidebar_item_transfer_menu", subtype);
      }}
      classes={{
        root: classNames(styles["menu-root"]),
        paper: classNames(styles["menu-paper"]),
      }}
      {...props}
    >
      {foldersArray.map((folder) => (
        <AppMenuItem
          key={folder.id}
          onClick={() => {
            handleTransfer(folder.id);
            closeMenu("sidebar_item_transfer_menu", subtype);
            closeMenu("sidebar_item_actions_menu");
          }}
          className={styles["action-item"]}
        >
          {folder.id === "root" ? <RootFolderIcon /> : <FolderCloseIcon />}
          <div>{folder.name}</div>
        </AppMenuItem>
      ))}
    </MenuBasic>
  );
};
